import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findOperLog({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`operLog/findOperLogList`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  clear() {
		return new Promise((resolve, reject) => {
			axios.get(`operLog/clear`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  }
}